export const OPEN_POPUP_EVENT = "search-bar/open-popup";
export const CLOSE_POPUP_EVENT = "search-bar/close-popup";

export const DEBOUNCED_TIME_MS = 300;
export const MIN_INPUT_LEN_FOR_API_CALL = 3;
export const SUGGESTED_OR_RECENT_SEARCHES_LIMIT = 4;
export const RECENT_SEARCHES_LIMIT_IN_LOCAL_STORAGE = 6;
export const BRANDS_LIMIT_TO_SHOW = 4;

export const RECENT_SEARCHES_STORAGE_KEY = "recentSearchesTVG";
export const RECENT_SEARCHES_STORAGE_EVENT = "recent-search/set";

export const INIT_DATA_CACHE_KEY = "autosuggest-init-data";
export const INIT_DATA_CACHE_TTL = 10 * 60 * 1000;

export const ANALYTICS_KEY = "search/type";
export const ANALYTICS_DIRECT_INPUT = "direct-input";
export const ANALYTICS_RECENT_SEARCH = "recent-search";
export const ANALYTICS_SUGGESTED_SEARCH = "suggested-search";
export const ANALYTICS_SUGGESTED_BRAND = "suggested-brand";
export const ANALYTICS_SUGGESTED_PRODUCT = "suggested-product";
export const ANALYTICS_RECOMMENDED_SEARCH = "recommended-search";
export const ANALYTICS_RECOMMENDED_PRODUCT = "recommended-product";

export const RECOMMENDED_PRODUCTS_POD_ID = "ac_popular_products";
export const RECOMMENDED_SUGGESTIONS_POD_ID = "ac_popular_suggestions";

// Strings for translation file if needed in future
export const BRANDS = "Brands";
export const SEARCH = "Search";

export const DATA_LAYER_SEARCH_TYPE = "data-layer/search-type";

export const DATA_LAYER = Object.freeze({
  SUGGESTED_SEARCH: "Suggested Search",
  RECENT_SEARCH: "Recent Search",
  SUGGESTED_PRODUCT: "Suggested Product",
  SUGGESTED_BRAND: "Suggested Brand",
});
